import React, { useState, useEffect } from 'react';
import {  Button, Row, Col,Modal } from 'antd';
import dayjs from 'dayjs';
import {  CrewScheduleWorkmen, deleteScheduleWorkmen,AddRemoveEmployees,replaceScheduleWorkmen,scheduleOverride } from '../../services/crew';
import LocationIcon from "../../../../src/assets/Location_Icon.svg"
import SettingIcon from "../../../../src/assets/Setting_Icon.svg";
import PeopleIcon from "../../../../src/assets/People_Icon.svg";
import TimerIcon from "../../../../src/assets/Timer_Icon.svg";
import { message, Spin } from "antd";
import SmartTable from './SmartTable';
import HOC from './HOC';
import ScheduleStatus from './ScheduleStatus';
import useAuth from '../../hooks/useAuth';
import { getDetails } from '../../services/auth';
import { RemoveFilters } from './RemoveFilters';
import { sortEmployees } from './sortingUtils';
const Summary = ({ basicDetails = {}, employees = [], assignDate, onPrev, onSave, removed = [], editEmployeeStatus, scheduleOverridePermission, loading: parentLoading }) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false); // local loader state
  const [integrationResponse, setIntegrationResponse] = useState(null);
  // const [sortConfig, setSortConfig] = useState(null);
    const [sortConfig, setSortConfig] = useState({ field: "name", order: "ascend" });
  
  const originalTableData = React.useRef([]);
  const [scheduleModalVisible, setScheduleModalVisible] = useState(false);
  const [successAssignments, setSuccessAssignments] = useState([]);
  const [conflictAssignments, setConflictAssignments] = useState([]);
  const { userConfig } = useAuth();
  const isLoading = parentLoading || loading;
  const [permissions, setPermissions] = useState([]);
  const showSpecific = (parameter) => (permissions || []).find(
      (f) => f.feature && f.feature.toLowerCase().includes(parameter.toLowerCase())
  );
const subFind = (needle, source) =>
    source?.subFeatures?.find(
      (s) =>
          s?.name &&
          s.name.toString().toLowerCase().includes(needle.toString().toLowerCase())
    );
    const scheduleAccess = subFind('schedule management', showSpecific('crew & schedule management'));

const handleSort = (field, order) => {
    if (!order) {
      setTableData([...originalTableData.current]);
      setSortConfig(null);
      return;
    }
   const sorted = [...tableData].sort((a, b) => {
      let aVal = a[field];
      let bVal = b[field];
      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return order === 'ascend' ? 1 : -1;
      if (bVal == null) return order === 'ascend' ? -1 : 1;
      const aNum = Number(aVal);
      const bNum = Number(bVal);
      const isANumeric = !isNaN(aNum) && aVal !== '' && aVal !== null;
      const isBNumeric = !isNaN(bNum) && bVal !== '' && bVal !== null;
      if (isANumeric && isBNumeric) {
        return order === 'ascend' ? aNum - bNum : bNum - aNum;
      }
      aVal = String(aVal).toLowerCase();
      bVal = String(bVal).toLowerCase();
      if (order === 'ascend') {
        return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
      } else {
        return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
      }
    });
    setTableData(sorted);
    setSortConfig({ field, order });
  };

     const applyDefaultEmployeeSort = (rawData) => {

  // Ensure rawData is always an array
  if (!Array.isArray(rawData)) {
    return [];
  }

  return [...rawData].sort((a, b) => {
    const lastCompare = (a.lastName || '').localeCompare(
      b.lastName || '',
      undefined,
      { sensitivity: 'base' }
    );

    if (lastCompare !== 0) {
      return lastCompare;
    }

    return (a.firstName || '').localeCompare(
      b.firstName || '',
      undefined,
      { sensitivity: 'base' }
    );
  });
};
  const getEmployeeColumns = HOC('employee', { crewSchedulingPermissions: permissions,date: assignDate, crewId: basicDetails?._id, employees, onSort: handleSort, sortConfig });
  
const [date, setDate] = useState(dayjs().add(1, 'day')); 
const [tablePageSize, setTablePageSize] = useState(100);

useEffect(() => {
    const key = userConfig?.userid ? `employee-table-page-size-${userConfig.userid}` : null;
    if (!key || typeof window === "undefined") return;
    const stored = window.localStorage.getItem(key);
    const parsed = stored ? parseInt(stored, 10) : NaN;
    if (Number.isFinite(parsed) && parsed > 0) {
      setTablePageSize(parsed);
    }
  });
const baseHeaderStyle = {
    backgroundColor: "#EAEEFF",
    color: "black",
    borderRight: "1px solid #d9d9d9",
    fontWeight: "bold",
  };
  const employeeColumns = getEmployeeColumns.map(col => ({
    ...col,
    onHeaderCell: () => ({
      style: baseHeaderStyle,
    }),
  }));
// useEffect(() => {
//     const mappedData = (employees || []).map(emp => ({
//         ...emp,
//         scheduleIn: emp.scheduleIn || (basicDetails.startTime && dayjs.isDayjs(basicDetails.startTime) ? basicDetails.startTime.format('HH:mm') : basicDetails.startTime || ''),
//         scheduleOut: emp.scheduleOut || (basicDetails.endTime && dayjs.isDayjs(basicDetails.endTime) ? basicDetails.endTime.format('HH:mm') : basicDetails.endTime || ''),
//       }));
    
//     setTableData(mappedData);
//     originalTableData.current = mappedData;
//   }, [employees, basicDetails]);

 useEffect(() => {
  const mappedData = (employees || []).map(emp => ({
    ...emp,
    scheduleIn:
      emp.scheduleIn ||
      (basicDetails.startTime && dayjs.isDayjs(basicDetails.startTime)
        ? basicDetails.startTime.format('HH:mm')
        : basicDetails.startTime || ''),

    scheduleOut:
      emp.scheduleOut ||
      (basicDetails.endTime && dayjs.isDayjs(basicDetails.endTime)
        ? basicDetails.endTime.format('HH:mm')
        : basicDetails.endTime || ''),
  }));

  const sortedData = applyDefaultEmployeeSort(mappedData);

  setTableData(sortedData);
  originalTableData.current = sortedData;

}, [employees, basicDetails]); 
  useEffect(() => {
      getRolePermissionDetails();
  },[])
const getRolePermissionDetails = () => {
    getDetails(userConfig.orgId)
      .then((response) => {
        const fetchRole = response.data.find((role) => 
          role?.selectedRole?.toLowerCase().trim() === userConfig.role?.toLowerCase().trim() && 
          role?.selectedRoleType?.toLowerCase().trim() === userConfig.roleName?.selectedRoleType?.toLowerCase().trim()
        );
        setPermissions(fetchRole.permissions.cap.crewScheduling);
      })
      .catch((err) => {
        console.error(err);
      })
  }
const handleOverrideSchedule = async (selectedConflicts = null) => {
   
      try {
        const conflictsToUse = Array.isArray(selectedConflicts) && selectedConflicts?.length ? selectedConflicts : conflictAssignments;
        if (!conflictsToUse || conflictsToUse.length === 0) {
          message.warning('No conflicts to override.');
          return;
        }
         const flattened = conflictsToUse?.flatMap(item => {
          if (Array.isArray(item?.conflicts) && item?.conflicts.length) return item?.conflicts;
          if (item && item._id) return [item];
          return [];
        });
      if (!flattened.length) {
          message.warning('No conflict assignment objects found.');
          return;
        }
  // Use each conflict's own date/start/end directly (no conversion)
        // for (const c of flattened) {
        //   const payload = {
        //     newCrewId: basicDetails?._id,
        //     start: dayjs(basicDetails?.startTime).format('HH:mm'),
        //     end: dayjs(basicDetails?.endTime).format('HH:mm'),
        //     date: dayjs(basicDetails?.date).format('YYYY-MM-DD'),
        //     conflictingEmployees: [
        //       {
        //         _id: c?._id,
        //         crew: c?.crew,
        //         isScheduleOverridden: c?.isScheduleOverridden,
        //         employeeId: c?.employeeId,
        //         date: c?.date,
        //         start: c?.start,
        //         end: c?.end,
        //         createdAt: c?.createdAt,
        //       },
        //     ],
        //   };
        // // call override per conflict using the raw values from the conflict object
        //   await scheduleOverride(payload);
        // }
const payload = {
  newCrewId: basicDetails?._id,

  start: dayjs(
    basicDetails?.startTime
  ).format('HH:mm'),

  end: dayjs(
    basicDetails?.endTime
  ).format('HH:mm'),

  date: dayjs(
    basicDetails?.date
  ).format('YYYY-MM-DD'),

  // ✅ Combine all conflicts into one array
  conflictingEmployees: flattened.map(c => ({

    _id: c?._id,

    crew: c?.crew,

    isScheduleOverridden:
      c?.isScheduleOverridden,

    employeeId: c?.employeeId,

    date: c?.date,

    start: c?.start,

    end: c?.end,

    createdAt: c?.createdAt,

  })),

};
// ✅ Only ONE API call
await scheduleOverride(payload);
      const updatedFlattened = flattened.map(item => ({
           id: item?.employeeId || item?.id,
           shiftId: item?.shiftId,
           workRuleTransfer:basicDetails?.workRuleTransfer,
           payscale: basicDetails?.payScale,
           wbsIo: basicDetails?.eventName,
           task: basicDetails?.task,
           premium: basicDetails?.premium,
           scheduleIn: dayjs(basicDetails?.startTime).format('HH:mm'),
           scheduleOut: dayjs(basicDetails?.endTime).format('HH:mm'),
        assignDate: dayjs(basicDetails?.date)?.format('YYYY-MM-DD'),
           startTime:item?.start,
           endTime:item?.end,
      }));
        
        await replaceScheduleWorkmen(updatedFlattened);
        message.success('Schedule override completed');
        setTimeout(() => window.location.reload(), 700);
      } catch (err) {
        console.error('Override failed:', err);
        message.error('Error overriding schedule.');
      }
    };

  const handleCancelSchedule = () => {
    setScheduleModalVisible(false);
    window.location.reload();
  };
const handleCellChange = (key, dataIndex, value) => {
    setTableData(prev =>
      prev.map(row =>
        row.key === key ? { ...row, [dataIndex]: value } : row
      )
    );
  };

// const onUpdate = async (valueee) => {
//   try {
//     setLoading(true); // ✅ start loader

//     const userId = userConfig?.userid;

//     // ✅ Access check
//     const hasOwnedCrew = basicDetails?.crewOwnerId === userId;
//     if (scheduleAccess.edit.toLowerCase() === "myself" && !hasOwnedCrew) {
//       message.error(
//         "Employees not allowed as access is restricted to crews owned/created by you."
//       );
//       return;
//     }

//     /* ------------------ 1. ADD / REMOVE CREW MEMBERS ------------------ */

//     const employeesToAssign = valueee.map(item => ({
//       employeeId: item.id
//     }));

//     const payload = {
//       crewDetails: {
//         _id: basicDetails?._id,
//         startTime: basicDetails?.startTime?.format("HH:mm"),
//         endTime: basicDetails?.endTime?.format("HH:mm"),
//         date: assignDate
//       },
//       employeesToAssign
//     };

//     const response = await AddRemoveEmployees(payload);
//     const body = response?.data ?? response;

//     /* ------------------ 2. CONFLICT HANDLING ------------------ */

//     let conflicts = [];
//     if (Array.isArray(body?.conflictingEmployees)) {
//       conflicts = body.conflictingEmployees;
//     } else if (Array.isArray(body)) {
//       conflicts = body;
//     } else if (Array.isArray(body?.data)) {
//       conflicts = body.data;
//     }

//     const successes =
//       body?.createdAssignments ??
//       body?.createdAssignmentsCount ??
//       [];

//     setSuccessAssignments(successes);
//     setConflictAssignments(conflicts);
//     setScheduleModalVisible(true);

//     /* ------------------ 3. REMOVE EMPLOYEES ------------------ */

//     if (removed?.length > 0) {
//       for (const emp of removed) {
//         try {
//           const today = dayjs().format("YYYY-MM-DD");
//           const AssignDate = dayjs(assignDate).format("YYYY-MM-DD");

//           const deletePayload = {
//             person_number: emp.id,
//             start_date: today,
//             end_date: today,
//             assignDate: AssignDate
//           };

//           await deleteScheduleWorkmen(deletePayload);
//         } catch (err) {
//           console.error(
//             `deleteScheduleWorkmen error for ${emp.id}:`,
//             err
//           );
//         }
//       }
//     }

//     /* ------------------ 4. ADD EMPLOYEES (NON-CONFLICT ONLY) ------------------ */

//     const addedEmployees = valueee.filter(
//       emp => emp.changeFlag === "added"
//     );

//     // ❌ remove conflicted employees
//     const conflictIds = new Set(conflicts.map(c => c.id));

//     const nonConflictAddedEmployees = addedEmployees.filter(
//       emp => !conflictIds.has(emp.id)
//     );

//    if (nonConflictAddedEmployees.length > 0) {
//       const AssignDate = dayjs(assignDate).format("YYYY-MM-DD");

//       const crewSchedulePayload = nonConflictAddedEmployees.map(emp => ({
//         id: emp.id,
//         workRuleTransfer: basicDetails?.workRuleTransfer,
//         payscale: basicDetails?.payScale,
//         wbsIo: basicDetails?.eventName,
//         task: basicDetails?.task,
//         premium: basicDetails?.premium,
//         scheduleIn: emp?.scheduleIn,
//         scheduleOut: emp?.scheduleOut,
//         assignDate: AssignDate,
//         date: AssignDate
//       }));
//     await CrewScheduleWorkmen(crewSchedulePayload);
//     }
//   //  message.success("Updated successfully");
//   //   setTimeout(() => window.location.reload(), 1000);

//   } catch (err) {
//     console.error("onUpdate error:", err);
//     message.error("Something went wrong while updating!");
//   } finally {
//     setLoading(false); // ✅ stop loader
//   }
// };

 
  // Format start/end time for display
  
  const onUpdate = async (valueee) => {
  try {
    setLoading(true);

    const userId = userConfig?.userid;

    const hasOwnedCrew = basicDetails?.crewOwnerId === userId;
    if (scheduleAccess.edit.toLowerCase() === "myself" && !hasOwnedCrew) {
      message.error(
        "Employees not allowed as access is restricted to crews owned/created by you."
      );
      return;
    }
   /* ------------------ CHECK ADD / REMOVE ------------------ */
    const addedEmployees = valueee.filter(emp => emp.changeFlag === "added");
    const isRemoveOnly = addedEmployees.length === 0;
  /* ------------------ 1. ADD / REMOVE CREW MEMBERS ------------------ */
    const employeesToAssign = valueee.map(item => ({
      employeeId: item.id
    }));

    const payload = {
      crewDetails: {
        _id: basicDetails?._id,
        startTime: basicDetails?.startTime?.format("HH:mm"),
        endTime: basicDetails?.endTime?.format("HH:mm"),
        date: assignDate
      },
      employeesToAssign
    };
    const response = await AddRemoveEmployees(payload);
    const body = response?.data ?? response;
    /* ------------------ 2. CONFLICT HANDLING ------------------ */
    let conflicts = [];
    if (Array.isArray(body?.conflictingEmployees)) {
      conflicts = body.conflictingEmployees;
    } else if (Array.isArray(body)) {
      conflicts = body;
    } else if (Array.isArray(body?.data)) {
      conflicts = body.data;
    }
   const successes =
      body?.createdAssignments ??
      body?.createdAssignmentsCount ??
      [];
    // 🔥 SHOW MODAL ONLY IF ADD EXISTS
    if (!isRemoveOnly && conflicts.length > 0 || !isRemoveOnly ) {
      setSuccessAssignments(successes);
      setConflictAssignments(conflicts);
      setScheduleModalVisible(true);
    }

    /* ------------------ 3. REMOVE EMPLOYEES ------------------ */
    // if (removed?.length > 0) {
    //   for (const emp of removed) {
    //     try {
    //       const today = dayjs().format("YYYY-MM-DD");
    //       const AssignDate = dayjs(assignDate).format("YYYY-MM-DD");

    //       const deletePayload = {
    //         person_number: emp.id,
    //         start_date: today,
    //         end_date: today,
    //         assignDate: AssignDate,
    //         startTime: emp?.start,
    //         endTime: emp?.end,
    //         shiftId: emp?.shiftId,
    //       };

    //       await deleteScheduleWorkmen(deletePayload);
    //     } catch (err) {
    //       console.error(
    //         `deleteScheduleWorkmen error for ${emp.id}:`,
    //         err
    //       );
    //     }
    //   }
    // }

    if (removed?.length > 0) {
  try {
    const today = dayjs().format("YYYY-MM-DD");
    const AssignDate = dayjs(assignDate).format("YYYY-MM-DD");
   // Create array payload like second code
    const deletePayload = removed.map(emp => ({
      person_number: emp.id,
      start_date: today,
      end_date: today,
      assignDate: AssignDate,
      startTime: emp?.start,
      endTime: emp?.end,
      shiftId: emp?.shiftId,
    }));
    // Single API call
    const Result = await deleteScheduleWorkmen(deletePayload);
   // Handle failed records (same as second logic)
    const failedResults =
      Result?.data?.results?.filter(
        r => r.status === "failed"
      ) || [];
   if (failedResults.length > 0) {
      console.error("Failed deletions:", failedResults);
    }
    setLoading(false)

  } catch (err) {
    console.error("deleteScheduleWorkmen error:", err);
  }
}
/* ------------------ 4. ADD EMPLOYEES (NON-CONFLICT ONLY) ------------------ */
    if (!isRemoveOnly) {
      const conflictIds = new Set(conflicts.map(c => c.id));
   const nonConflictAddedEmployees = addedEmployees.filter(
        emp => !conflictIds.has(emp.id)
      );
   if (nonConflictAddedEmployees.length > 0) {
        const AssignDate = dayjs(assignDate).format("YYYY-MM-DD");
    const crewSchedulePayload = nonConflictAddedEmployees.map(emp => ({
          id: emp.id,
          workRuleTransfer: basicDetails?.workRuleTransfer,
          payscale: basicDetails?.payScale,
          wbsIo: basicDetails?.eventName,
          task: basicDetails?.task,
          premium: basicDetails?.premium,
          scheduleIn: emp?.scheduleIn,
          scheduleOut: emp?.scheduleOut,
          assignDate: AssignDate,
          date: AssignDate
        }));
      const Response= await CrewScheduleWorkmen(crewSchedulePayload);
       setIntegrationResponse(Response.data.results);
      //  setScheduleModalVisible(true);
      }
    }
    RemoveFilters(userConfig);
    // 🔥 ONLY REMOVE → DIRECT REFRESH, NO MODAL
    if (isRemoveOnly) {
      window.location.reload();
    }
} catch (err) {
    console.error("onUpdate error:", err);
    message.error("Something went wrong while updating!");
  } finally {
    setLoading(false);
  }
};
const formatTime = t =>
    t && dayjs.isDayjs(t) ? t.format('HH:mm') : (typeof t === 'string' ? t : '');

 const formatDate = (d) => {
    const parsed = dayjs(d);
    return parsed && parsed.isValid() ? parsed.format('MM-DD-YYYY') : '';
  };
 const handleSaveClick = async () => {
  const userId = userConfig?.userid;
// Check if this crew is owned by logged-in user
    const hasOwnedCrew = basicDetails?.crewOwnerId === userId;
    if (basicDetails?._id) {
      if (scheduleAccess.create.toLowerCase() === 'myself' && !hasOwnedCrew) {
        message.error('Assignment not allowed as access is restricted to crews owned/created by you.');
        return;
      }
    }
   setLoading(true);
    try {
      await onSave(tableData);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="crew-summary-container" style={{marginTop:'-25px'}}>
      <h2 className="summary-title">Basic Details</h2>
      <div className="summary-grid">
        {/* Crew & Supervision */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={PeopleIcon}
                            alt="location"
                            style={{ width: 30, height: 22, marginRight: 6 }}
                          />
                          Crew & Supervision            </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Crew Name</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.crewName}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Crew Lead</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.crewLead}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Supervisor</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.supervisor}</span>
          </div>
        </div>
        {/* Shift Date & Timing */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span style={{ display: "flex", alignItems: "center" }}>
              <img
                src={TimerIcon}
                alt="location"
                style={{ width: 30, height: 22, marginRight: 6 }}
              />
              Shift Date & Timing
            </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Date</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatDate(assignDate)}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Start Time</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatTime(basicDetails?.startTime)}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">End Time</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatTime(basicDetails?.endTime)}</span>
          </div>
        </div>
        {/* Work details */}
        <div className="summary-section" style={{marginTop:'-25px'}}>
          <div className="summary-section-header" >
            {/* <span role="img" aria-label="work">&#128295;</span> Work details */}
             <span style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={SettingIcon}
                            alt="location"
                            style={{ width: 30, height: 22, marginRight: 6 }}
                          />
                          Work details           </span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Task</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.task}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Premium</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.premiumDescription}</span>

          </div>
          <div className="summary-row">
            <span className="summary-key">Pay Scale</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.payscaleDescription}</span>

          </div>
          {/* <div className="summary-row">
            <span className="summary-key">Event</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventName}</span>
          </div> */}
          {/* <div className="summary-row">
            <span className="summary-key">Event description</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventDescription}</span>
          </div> */}
        </div>
        {/* Location & Compensation */}
        <div className="summary-section" style={{marginTop:'-25px'}}>
          <div className="summary-section-header">
<span style={{ display: "flex", alignItems: "center" }}>
  <img
    src={LocationIcon}
    alt="location"
    style={{ width: 30, height: 22, marginRight: 6 }}
  />
  Location & Compensation
</span>
</div>
          <div className="summary-row">
            <span className="summary-key">Venue</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.venue}</span>
          </div>
          {/* <div className="summary-row">
            <span className="summary-key">Pay Scale</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.payscaleDescription}</span>
          </div> */}
          <div className="summary-row">
            <span className="summary-key">Event</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventName}</span>
          </div>
           <div className="summary-row">
            <span className="summary-key">Event Description</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventDescription}</span>

          </div>
        </div>
      </div>
      <div className="assigned-employees-header" style={{marginTop:'-25px'}}>
        <span>
          Assigned Employees
          {assignDate ? ` • ${formatDate(assignDate)}` : ''}
        </span>
      </div>
      <SmartTable
        tableKey="crew-summary-table"
        columns={employeeColumns}
        dataSource={tableData}
        pagination={{
          pageSize: tablePageSize,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={(pagination, filters, sorter, extra) => {
          if (pagination && pagination.pageSize) {
            setTablePageSize(pagination.pageSize);
            const key = userConfig?.userid ? `employee-table-page-size-${userConfig.userid}` : null;
            if (key && typeof window !== "undefined") {
              window.localStorage.setItem(key, String(pagination.pageSize));
            }
          }
        }}
        // scroll={{ x: 'max-content' }}
        scroll={tableData?.length ? { x: "100%", y: 455 } : { y: 455 } }
        bordered
        className="crew-summary-table"
      />
      <Row justify="end" style={{ marginTop: 24 }}>
        <Col>
          <Button style={{ marginRight: 8 }} onClick={onPrev} disabled={loading}>
            Previous
          </Button>
        </Col>
        {basicDetails?._id ? (
          <Col>
            <Button type="primary" onClick={() => onUpdate(tableData)} disabled={isLoading}>
              {/* Update */}
              {isLoading ? <Spin size="small" /> : "Update"}
            </Button>
          </Col>
        ) : (
          <Col>
            <Button type="primary" onClick={handleSaveClick} disabled={isLoading}>
              {isLoading ? <Spin size="small" /> : "Save"}
            </Button>
          </Col>
        )}
      </Row>
       <Modal
              // open={scheduleModalVisible}
               open={scheduleModalVisible && loading !== true}
              footer={null}
              closable
              onCancel={handleCancelSchedule}
              width={950}
              bodyStyle={{ padding: 0, borderRadius: 12, overflow: 'hidden' }}
            >
              <ScheduleStatus
                // assignedEmployees={assignedEmployees}
                assignDate={dayjs(assignDate)?.format('MM-DD-YYYY')}
                onOverride={handleOverrideSchedule}
                onCancel={handleCancelSchedule}
                successToAssign={successAssignments}
                conflictToAssign={conflictAssignments}
                integrationResponse={integrationResponse}
                
                scheduleOverridePermission={scheduleOverridePermission}
              />
            </Modal>

      <style>{`
        .crew-summary-container {
          font-family: 'Segoe UI', Arial, sans-serif;
          background: #fff;
          padding: 24px;
        }
        .summary-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
        }
        .summary-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-bottom: 24px;
        }
        // .summary-section {
        //   background: #eaf2ff;
        //   border-radius: 12px;
        //   padding: 0 0 12px 0;
        //   margin-bottom: 0;
        //   box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        // }
        .summary-section {
  background: transparent;   /* no fixed background */
  border-radius: 12px;
  padding: 0 0 12px 0;
  margin-bottom: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.03);
}

        .summary-section-header {
          // background: #dbeafe;
                    background: #EAEEFF;

          font-weight: 500;
          padding: 8px 12px;
          // border-radius: 12px 12px 0 0;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          font-size: 15px;
        }
        .summary-row {
          display: flex;
          align-items: center;
          background: #f8fafc;
          padding: 4px 12px;
          font-size: 14px;
          border-bottom: 1px solid #f0f0f0;
        }
        .summary-row:last-child {
          border-bottom: none;
        }
        .summary-key {
          flex: 1;
          color: #222;
        //   background: #B4B4B450;
        }
        .summary-divider {
          width: 1px;
          height: 20px;
          background: #dbeafe;
          margin: 0 12px;
        }
        .summary-value {
          flex: 1;
          text-align: right;
          color: #222;
          font-weight: 700;
        }
        .assigned-employees-header {
          font-size: 16px;
          font-weight: 500;
          margin: 32px 0 12px 0;
        }
        .crew-summary-table .ant-table-thead > tr > th {
          background: #f5f7fa;
          font-weight: 500;
        }
        .crew-summary-table .ant-table-cell {
          font-size: 14px;
        }
        .crew-summary-table .ant-table-tbody > tr > td {
          padding: 6px 8px;
        }
      `}</style>
    </div>
  );
};

export default Summary;

